import React, { Component } from 'react'
import './App.css'
import Landing from './components/Landing'
import Booking from './components/Booking'
import CartContainer from './components/CartContainer'
import LostAsylum from './components/LostAsylum'
import VeryBadNight from './components/VeryBadNight'
import Abattoir from './components/Abattoir'
import Yakuza from './components/Yakuza'
import Tombeau from './components/Tombeau'
import TeamBuilding from './components/TeamBuilding'
import FAQ from './components/FAQ'
import GiftCard from './components/GiftCard'
import Confirmation from './components/Confirmation'
import Payment from './components/Payment'
import CustomCookieBanner from './components/CustomCookieBanner'
import PopInExpiration from './components/PopInExpiration'
import NotFound from './components/NotFound'
import { Cookies } from 'react-cookie-banner'
import { ParallaxProvider } from 'react-scroll-parallax'
import { injectIntl } from "react-intl"
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import SiteTransition from './images/Transition/glitch.webp'
import { API_ROOT } from './api-config'
import axios from 'axios'
import { isIE } from 'react-device-detect'

const cookies = new Cookies()

const buildAPI_URL = (idOrder, tokenOrder) => {
  return `${API_ROOT}FrontGetOrderDetails.php?id_order=${idOrder}&token_order=${tokenOrder}`
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

class App extends Component {
  constructor(props) {
    super(props)
    this.state={
      showCookieBanner: false,
      showPopInExpiration: false,
      timeLeft: 0,
      needMoreTime: false,
      appKey: 1
    }
  }

  getPrices = async (list, html = true) => {
    try {
      const response = await axios.get(`${API_ROOT}GetCompanyPrices.php`);
      let output = "<ul>";
      list.forEach(element => {
        const price = parseInt(response.data["prix" + element + "j"]);
        output += "<li>" + element + " personnes: " + price + "&euro; soit " + parseInt(price / element) + "&euro; par personne</li>";
      });
      output += "<ul>";
      if (html)
        return output;
      else
        return response.data;
    } catch (error) {
      console.error("Error while loading prices :", error);
      return null;
    }
  };

  triggerPopInExpiration = async () => {
    const cookies = new Cookies()
    if (cookies.get("orderDetails") && cookies.get("orderDetails").order_details && cookies.get("orderDetails").order_details.expiracy) {
      const expiracy = cookies.get("orderDetails").order_details.expiracy * 1000
      const timeLeft = new Date(expiracy) - new Date().getTime()
      // for testing
      // const timeLeft = 10000 * 1
      const minutesBeforeWarning = 9
      const warning = 60000 * minutesBeforeWarning
      const timeBeforeWarning = timeLeft - warning
      if (timeBeforeWarning > 0) {
        setTimeout(() => {
          if (cookies.get("orderDetails") != null && cookies.get("orderDetails")["order_details"]) {
            this.setState({
              showPopInExpiration: true,
              timeLeft: timeLeft,
              needMoreTime: false
            })
          }
        }, timeBeforeWarning)
        setTimeout(async () => {
          if (!this.state.needMoreTime) {
            this.resetCart()
          }
        }, timeLeft)
      }
    }
  }

  resetCart = async (disableDeleteAllBookings = false) => {
    this.setState({
      showPopInExpiration: false,
    })
    console.log("time is up")
    const cookies = new Cookies()
    let bookings = cookies.get("bookings")
    if (bookings && !disableDeleteAllBookings) {
      this.deleteAllBookings()
    }

    bookings = []
    cookies.set('bookings', bookings, { path: '/', expires: new Date('2020-12-17T03:24:00') })
    cookies.set('cart_step', 0, { path: '/', expires: new Date('2020-12-17T03:24:00') })

    if (!window.location.href.indexOf("confirmation") > 0) {
      this.setState({ appKey: this.state.appKey + 1})
    }
  }

  getOrderInfo = async () => {
    const cookies = new Cookies()
    const idOrder = cookies.get('orderDetails').id_order_escape
    const tokenOrder = cookies.get('orderDetails').id_order_escape_token
    axios.get(buildAPI_URL(idOrder, tokenOrder))
      .then(response => {
        if (!response.data.result || (response.data.result && response.data.rooms && response.data.rooms.length == 0) || (response && response.data && response.data.status && response.data.status == 'blocked_waiting_multipayment')) {
          this.resetCart(true)
          const cookies = new Cookies()
          cookies.remove("orderDetails")
          cookies.remove("bookings")
          cookies.remove("bookingsTokens")
          this.setState({ appKey: this.state.appKey + 1})
        } else {
          const cookies = new Cookies()
          let orderDetails = cookies.get("orderDetails")
          orderDetails.order_details = response.data
          cookies.set('orderDetails', orderDetails, { path: '/', expires: new Date('2040-12-17T03:24:00') })
          this.triggerPopInExpiration()
        }
      })
      .catch(error => {
        const cookies = new Cookies()
        cookies.remove("orderDetails")
        cookies.remove("bookings")
        cookies.remove("bookingsTokens")
        this.setState({ appKey: this.state.appKey + 1})
        console.log(error)
      })
  }

  deleteAllBookings = async () => {
    const cookies = new Cookies()
    const bookings = cookies.get("bookings")
    const tokens = cookies.get("bookingsTokens")
    const url = `${API_ROOT}FrontDeleteRoomReservation.php`

    bookings.forEach( async (booking) => {
      let token = tokens.find(x => x.id_room_reservation.toString() === booking.id)

      const body = {
        id_reservation: booking.id.toString(),
        token_reservation: token.id_room_reservation_token
      }

      return await fetch(url, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
        method: 'post',
        body: buildFormBody(body)
      })
      .then(async (response) => response.json())
      .then(async (data) => {
        console.log(data)
        if (data.result === false) {
          const cookies = new Cookies()
          cookies.remove("orderDetails")
          cookies.remove("bookings")
          cookies.remove("bookingsTokens")
          console.log("done")
        }
        this.setState({ appKey: this.state.appKey + 1})
      })
      .catch(error => console.log(error))
    })
  }

  giveMoreTime = async () => {
    await this.getOrderInfo()
    this.setState({
      showPopInExpiration: false,
      needMoreTime: true
    })
  }

  closeBanner = () => {
    cookies.set('onehour', 'acceptedCookies', { path: '/', expires: new Date('2020-12-17T03:24:00') })
    this.setState({ showCookieBanner: false})
  }

  checkCart = () => {
    const cookies = new Cookies()
    let orderDetails = cookies.get("orderDetails")
    if (orderDetails) {
      this.getOrderInfo()
    }
  }

  componentDidMount() {
    const hasAcceptedCookies = Object.keys(cookies.getAll()).length !== 0

    if (!hasAcceptedCookies) {
      this.setState({ showCookieBanner: true })
    }
    this.checkCart()
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    if (isIE) return <div> Internet Explorer n'est pas supporté. Essayez avec Chrome/Opera/Firefox.</div>
    return (
      <div className="App" key={this.state.appKey}>
        <div id="site-transition" className="site-transition">
          <img src={SiteTransition} alt="Escape game Paris" />
        </div>
        <ParallaxProvider>
          <Switch>
            <Route exact path="/" render={() =>
              <Landing
                lang={this.props.lang}
                handleLang={(lang) => this.props.handleLang(lang)}
                handleExpiration={() => this.triggerPopInExpiration()}
              />}
            />
            <Route exact path="/reserver" render={() =>
              <Booking
                lang={this.props.lang}
                handleExpiration={() => this.triggerPopInExpiration()}
                getPrices={(list, html) => this.getPrices(list, html)}
              />}
            />
            <Route exact path="/cart" render={() =>
                <CartContainer
                lang={this.props.lang}
                handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/lost-asylum" render={() =>
                <LostAsylum
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/very-bad-night" render={() =>
                <VeryBadNight
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/abattoir" render={() =>
                <Abattoir
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/yakuza" render={() =>
                <Yakuza
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/expedition-maudite" render={() =>
                <Tombeau
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  handleExpiration={() => this.triggerPopInExpiration()}
                />}
            />
            <Route exact path="/team-building" render={() =>
                <TeamBuilding
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  getPrices={(list, html) => this.getPrices(list, html)}
                />}
            />
            <Route exact path="/faq" render={() =>
                <FAQ
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  getPrices={(list, html) => this.getPrices(list, html)}
                />}
            />
            <Route exact path="/carte-cadeaux" render={() =>
                <GiftCard
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                  getPrices={(list, html) => this.getPrices(list, html)}
                />}
            />
            <Route exact path="/confirmation" render={() =>
                <Confirmation
                />}
            />
            <Route exact path="/payment" render={() =>
              <Payment
              />}
            />
            <Route exact path="/404" render={() =>
                <NotFound
                  lang={this.props.lang}
                  handleLang={(lang) => this.props.handleLang(lang)}
                />}
            />
            <Redirect to="/404" />
          </Switch>
          { this.state.showCookieBanner
            ? <CustomCookieBanner acceptCookies={this.closeBanner}/>
            : null
          }
        </ParallaxProvider>
        {
          this.state.showPopInExpiration
          ? <PopInExpiration
              timeLeft={this.state.timeLeft}
              closePopIn={() => this.setState({ showPopInExpiration: false })}
              giveMeTime={() => this.giveMoreTime()}
            />
          : null
        }
      </div>
    );
  }
}

export default withRouter(injectIntl(App))



// WEBPACK FOOTER //
// ./src/App.js